/** Resolve edge-management settings paths for the current app shell. */
export const getEdgeSettingsPaths = (pathname: string) => {
  if (pathname.startsWith('/red-hat-manager') || pathname.includes('/red-hat-manager')) {
    return {
      repositories: '/red-hat-manager/repositories',
      authentications: '/red-hat-manager/authentications',
    };
  }
  if (pathname.startsWith('/acm-openshift') || pathname.includes('/acm-openshift')) {
    return {
      repositories: '/acm-openshift/edge-management/repositories',
      authentications: '/acm-openshift/edge-management/authentications',
    };
  }
  if (pathname.startsWith('/ansible') || pathname.includes('/ansible')) {
    return {
      repositories: '/ansible/edge-management/repositories',
      authentications: '/ansible/edge-management/authentications',
    };
  }
  return {
    repositories: '/repositories',
    authentications: '/authentications',
  };
};

/** Resolve image-builds list/create base path for the current app shell. */
export const getImageBuildsBasePath = (pathname: string) => {
  if (pathname.startsWith('/red-hat-manager') || pathname.includes('/red-hat-manager')) {
    return '/red-hat-manager/images';
  }
  if (pathname.startsWith('/acm-openshift') || pathname.includes('/acm-openshift')) {
    return '/acm-openshift/edge-management/image-builds';
  }
  if (pathname.startsWith('/ansible') || pathname.includes('/ansible')) {
    return '/ansible/edge-management/image-builds';
  }
  return '/image-builds';
};
